import { registerComponent } from '../app'
import { VARIANT_CHANGE } from '../events'

const VariantPrimaryBorder = (scope, el) => {
	scope.on(VARIANT_CHANGE, variant => {
		if (!variant.primary_color || !variant.primary_color.length) return
		el.style.borderColor = variant.primary_color
	})
}

registerComponent('variant-primary-border', VariantPrimaryBorder)
